// Vue CLI embeds these values when npm run build runs. Keep the legacy routes
// available so this temporary contractor portal can be disabled in one build.
const enabled = process.env.VUE_APP_CONTRACTOR_PORTAL_ENABLED === 'true'

function portalUrl(value, setting) {
  if (!enabled) return null

  try {
    const url = new URL(value)
    if (url.protocol === 'https:' || url.protocol === 'http:') return url.href
  } catch (error) {
    // The descriptive error below also handles missing values.
  }

  throw new Error(`${setting} must be an absolute HTTP(S) URL when the contractor portal is enabled.`)
}

export const contractorPortal = {
  enabled,
  loginUrl: portalUrl(process.env.VUE_APP_CONTRACTOR_PORTAL_LOGIN_URL, 'VUE_APP_CONTRACTOR_PORTAL_LOGIN_URL'),
  dashboardUrl: portalUrl(process.env.VUE_APP_CONTRACTOR_PORTAL_DASHBOARD_URL, 'VUE_APP_CONTRACTOR_PORTAL_DASHBOARD_URL'),
  logoutUrl: enabled ? new URL('/legacy/logout', process.env.VUE_APP_CONTRACTOR_PORTAL_DASHBOARD_URL).href : null,
}
